import {
  GET_AI_RECOMMENDATION_SALES_REP_CLASSIFICATION_FAILURE,
  GET_AI_RECOMMENDATION_SALES_REP_CLASSIFICATION_SUCCESS,
  GET_SALES_REP_CLASSIFICATION_LIST_FAILURE,
  GET_SALES_REP_CLASSIFICATION_LIST_SUCCESS,
  RESET_SALES_REP_CLASSIFICATION,
  SET_CLASSIFICATION_QUESTIONNAIRE,
  SET_CLASSIFICATION_TYPE,
  SET_SALES_REP_CLASSIFICATION_ID,
} from "../Action/actionTypes";

interface InitialStateProps {
  loading: boolean;
  classificationType: string;
  classificationSettings: Object;
  aiClassificationData: Object;
  aiError: string;
  salesRepClassificationId: string;
  salesRepClassificationList: object[];
}
const initialState: InitialStateProps = {
  loading: false,
  classificationType: "",
  classificationSettings: {},
  aiClassificationData: {},
  aiError: "",
  salesRepClassificationId: "",
  salesRepClassificationList: []
};

const salesRepClassificationReducer = (state = initialState, action: any) => {
  switch (action.type) {
    case SET_CLASSIFICATION_TYPE:
      return {
        ...state,
        classificationType: action.payload,
      };
    case SET_CLASSIFICATION_QUESTIONNAIRE:
      return {
        ...state,
        classificationSettings: action.payload,
      };
    case RESET_SALES_REP_CLASSIFICATION:
      return {
        ...initialState,
      };

    case GET_AI_RECOMMENDATION_SALES_REP_CLASSIFICATION_SUCCESS: {
      let isExist = [
        "Performer",
        "Rationalist",
        "Harmonizer",
        "Optimizer",
      ].includes(action.payload?.salesRepClassification);
      return {
        ...state,
        aiClassificationData: action.payload,
        classificationType: isExist
          ? action.payload.salesRepClassification
          : state.classificationType,
      };
    }

    case GET_AI_RECOMMENDATION_SALES_REP_CLASSIFICATION_FAILURE:
      return {
        ...state,
        aiError: action.payload,
      };

    case SET_SALES_REP_CLASSIFICATION_ID: return {
      ...state,
      salesRepClassificationId: action.payload
    }

    case GET_SALES_REP_CLASSIFICATION_LIST_SUCCESS: return {
      ...state,
      salesRepClassificationList: action.payload
    }

    case GET_SALES_REP_CLASSIFICATION_LIST_FAILURE: return {
      ...state,
      salesRepClassificationList: []
    }

    default:
      return state;
  }
};
export default salesRepClassificationReducer;
